import React from "react";
import { Heading, IconOnePass as BaseIconOnePass, LinkButton, Text, } from "@catchoftheday/cg-components";
import { MigrationNudgeContentZone } from "../../layouts/MigrationNudgeLayout/MigrationNudgeLayout";
const IconOnePass = (props) => (<BaseIconOnePass aria-label="OnePass" color="onePass.primary" height="1em" width="auto" mt={{ xs: -1, md: -2 }} {...props}/>);
export const Content = ({ CTAUrl, onCTAClick }) => {
    return (<MigrationNudgeContentZone>
      <Heading.h3 fontWeight="bold" fontSize={{ xs: "base", md: "2xl" }} mb={4} mt={0}>
        Transfer your
        <IconOnePass mx={1}/>
        subscription
      </Heading.h3>
      <Text fontSize={{ xs: "sm", md: "lg" }} fontWeight="medium" mb={4} mt={0}>
        OnePass has a new home. Transfer your subscription to activate your new
        benefits.
      </Text>
      <LinkButton variant="onePassPrimary" fontSize="sm" fontWeight="semibold" onClick={onCTAClick} width="auto" href={CTAUrl}>
        Show me how
      </LinkButton>
    </MigrationNudgeContentZone>);
};
